import React, { useEffect } from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useHistory } from "react-router";
import InputBase from '@mui/material/InputBase';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import SearchIcon from '@mui/icons-material/Search';
import NestedList from '../../../plugins/insurance/nestedMenu';
import MoreIcon from '@mui/icons-material/MoreVert';
import logo from "../../../assets/logo-mediassist.png";
import Drawer from '@mui/material/Drawer';
import Autocomplete from '@mui/material/Autocomplete';
import { LogoutComponent } from "../../../auth/logout";
import { Link } from "react-router-dom";
import { getProviderDetails , getAllContracts, getChildEntityRelation, RouteToDashboard, AppointmentDetails, } from "../../../services/insurance/common";
import { getNativeSelectUtilityClasses } from '@mui/material';
import { USER } from '../../../constants/insurance/constant';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  height: '60%',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'relative',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#e0e4e7',
  color: '#ffffff',
  right: 0,
  borderTopRightRadius: '2px',
  borderBottomRightRadius: '2px'
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: '#ffffff',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em)`,
    paddingRight: `calc(1em + ${theme.spacing(5)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50ch',
      cursor: 'pointer',
      color: '#ffffff',
    },
  },
}));

export default function TopNavBar(props) {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const firstName = localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).firstName : "";
  const [entityId] =  React.useState(localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).entityId : null);
  const [providerDetails, setProviderDetails] = React.useState();
  const [searchName, setSearchName] = React.useState("");
  const [searchId, setSearchId] = React.useState("");
  const [searchNameLabels, setSearchNameLabels] =  React.useState([{ label: 'Request/Esales Id' }, { label: 'Equote Id' },{label : 'Member Id'},{ label: 'Application No' }, { label: 'Name' }, {label : 'Contact No'}]);
  const [pathname, setPathname] = React.useState(props.location.pathname);

  useEffect(() => {
    let isMounted = true;
        if (isMounted) {
            if (props.location.pathname !== pathname) {
              setPathname(props.location.pathname);
              setSearchId(""); 
              setSearchName("");
            }
            if(["/insureradmin/appointments/", "/insureragent/appointments/", "/insureradmin/appointments", "/insureragent/appointments"].includes(props.location.pathname)){
              setSearchNameLabels([{ label: 'Request/Esales Id' }, {label : 'Member Id'}, { label: 'Application No' }, { label: 'Name' }, {label : 'Contact No'}])
            }else{
              setSearchNameLabels([{ label: 'Request/Esales Id' }, { label: 'Equote Id' },{label : 'Member Id'},{ label: 'Application No' }, { label: 'Name' }, {label : 'Contact No'}])

            }
        }
        return () => { isMounted = false };

  },[props.location.pathname, pathname])


  const [state, setState] = React.useState({
    left: false
  });

  useEffect(() => {
    let isMounted = true;  
    if(localStorage.getItem('access_token')){
      getProviderDetails(entityId).then((response) => {
        if (isMounted){
          let user = USER.user;
          user.entityName = response.entityName;
          localStorage.setItem("user_details",JSON.stringify(user));
          setProviderDetails(response);
        }
        })
      getChildEntityRelation(entityId).then((response) => {
        if(response){
          localStorage.setItem("children",JSON.stringify(response))
        }
      })
      getAllContracts().then(response => {
        if(response){
          localStorage.setItem("mb_contracts",JSON.stringify(response))
        }
      })
     
    }     
    return () => { isMounted = false }; 
    
  },[entityId]) 

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const toggleDrawerOnClick = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
    return open;
  };

  const createAppointment = () => {
    history.push("/"+localStorage.getItem("roleName")+"/create/appointments")
  }

  const showAppointment = () => {
    history.push("/"+localStorage.getItem("roleName")+"/appointments");
  }


  const searchByName = (event, values) => {
    values && values.label ?   setSearchName(values.label) : setSearchName("");
  }

  const searchById = (event) => {
    console.log("event >>", event.target.value)
    setSearchId(event.target.value)
  }
  function callAppointmentDetails() {
    let ob = {
      Id: searchId,
      Name: searchName,
      isSearch:true
    }
    props.onSearchById(ob);
    callAPI(ob)
  }

  const callAPI = (searchAppointment) => {
  
      AppointmentDetails(searchAppointment, 0, null, null)
      .then(data => {
        if (data && data.activerequests && data.activerequests.appointmentList && searchName !== "Equote Id") {
          let obj = {
            requests: data && data.activerequests && data.activerequests.appointmentList ? data.activerequests.appointmentList : [],
            totalRows:  data && data.activerequests.totalActiveRequest ? data.activerequests.totalActiveRequest : 0,
            requestedStatusId : 0
          }
          props.onSearchedDetails(obj);
          // RouteToDashboard(history,0,obj)
        }else if (data && data.queueRequests && data.queueRequests.isSuccess && data.queueRequests.queueList ){

          let obj = {
            requests: data && data.queueRequests && data.queueRequests.queueList ? data.queueRequests.queueList : [],
            totalRows: state && state.totalRows? state.totalRows:data.queueRequests.totalQueueRequest,
            requestedStatusId : 1
          }
          props.onSearchedDetails(obj);
          // RouteToDashboard(history,1,obj)
        }
        else{
           let obj = {
              requests: [], 
              totalRows:   0,
              requestedStatusId : ["/insureradmin/appointments/", "/insureragent/appointments/", "/insureradmin/appointments", "/insureragent/appointments"].includes(props.location.pathname)?0:1,
            }
            props.onSearchedDetails(obj);
            // if(["/insureradmin/appointments/", "/insureragent/appointments/", "/insureradmin/appointments", "/insureragent/appointments"].includes(props.location.pathname)){
            //   RouteToDashboard(history,0,obj)
            // }
            // else{
            // RouteToDashboard(history,1,obj)
            // }
        }
      })
      .catch(e => console.log(e))
    
  }

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
     <NestedList providerDetails={providerDetails} toggleDrawerFunction={toggleDrawerOnClick(anchor, false)} anchorValue={anchor}></NestedList>
    </Box>
  );


  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={createAppointment}>Profile</MenuItem>
      <MenuItem onClick={showAppointment}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      className="flex justify-start w-96"
    >
      <LogoutComponent mobileView={true}></LogoutComponent>
    </Menu>
  );

  const resetPagination =() =>{
    localStorage.removeItem('req');
    let pgTrack = JSON.parse(localStorage.getItem("pageTracking"))
    if(pgTrack){
      pgTrack.page =1;
      pgTrack.sla=false;
      pgTrack.startTime="";
      pgTrack.endTime="";
      localStorage.setItem("pageTracking",JSON.stringify(pgTrack))
    }
  }
  return (
    <Box sx={{ flexGrow: 1 }} className="fixed inset-x-0 top-0 opacity-100 z-20">
      <AppBar position="static">
        <Toolbar className="bg-nav-bar-header h-16">
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2, color: '#ffffff' }}
          >
            <React.Fragment key={'left'}>
              <MenuIcon onClick={toggleDrawer('left', true)} />
              <Drawer
                anchor={'left'}
                open={state['left']}
                onClose={toggleDrawer('left', false)}
              >
                {list('left')}
              </Drawer>
            </React.Fragment>

          </IconButton>
          <Typography
            variant="h6"
            noWrap
            className="pr-10"
            component="div"
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            <Link to ={{pathname:"/"}}>
            <div className="w-32" onClick={()=>{resetPagination()}}>
              <img className="w-full" alt="logo of insurer" src={logo} />
            </div>
            </Link>
          </Typography>


          <Autocomplete
            sx={{
              display: 'inline-block',
              '& input': {
                width: '200px',
                borderRadius: '5px',
                padding: '7px',
                bgcolor: 'background.paper',
                cursor: "pointer",
                background: "#2c4d5f",
                color: '#fff',
              },
              
            }}
            id="custom-input-demo"
            options={searchNameLabels}
            inputValue={searchName ? searchName : ''}
            onChange={searchByName}
            onInputChange={(_, newInputValue) => {
              setSearchName(newInputValue)
            }}
            renderInput={(params) => (
              <div ref={params.InputProps.ref} className="flex relative">
                <input type="text" {...params.inputProps} placeholder='Select Id' />
               </div>

            )}
          />

          <Search>
            <StyledInputBase
              value={searchId}
              onChange={searchById}
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
              onKeyPress={(e)=>{if(e.key === "Enter" ) callAppointmentDetails() }}
            />
            <SearchIconWrapper onClick={callAppointmentDetails}>
              <SearchIcon
                className="text-blue-900"
              ></SearchIcon>
            </SearchIconWrapper>
          </Search>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              className="cursor-default"
              aria-haspopup="true"
              color="inherit"
            >

              <Avatar className="uppercase text-center" sx={{ width: 30, height: 30, fontSize:'15px', bgcolor: '#dc3e4d' }}>
                {firstName.charAt(0)}
              </Avatar>
             
            </IconButton>
            <LogoutComponent mobileView={false}></LogoutComponent>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              className="text-gray-100"
            >
              <MoreIcon className="text-gray-100" />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
}
